import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  LinearProgress,
  SelectChangeEvent,
  CircularProgress,
} from '@mui/material';
import './TankSelect.css';
import { StorageUnit } from './embryoCulture.helpers';
import { RequiredLabel } from '../../../utils/commonUtils';

interface GobletSelectProps {
  goblets: StorageUnit[];
  selectedGoblet: number | null;
  onChange: (value: string) => void;
  label?: string;
  loading: boolean;
  hasError?: boolean;
}

const GobletSelect: React.FC<GobletSelectProps> = ({
  goblets,
  selectedGoblet,
  onChange,
  label = 'Goblet',
  loading,
  hasError = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    
    // eslint-disable-next-line no-console
    console.log('Selected event.target.value ID:', event.target.value);
    const gobletId = event.target.value;
    // eslint-disable-next-line no-console
    console.log('Selected Goblet ID:', gobletId);
    onChange(gobletId);
  };

  return (
    <FormControl fullWidth className="tank-select-container" error={hasError} >
      <InputLabel shrink={selectedGoblet !== null}
        sx={{ display: goblets.length === 0 ? 'none' : 'block' }} >{label}</InputLabel>
      <Select
        value={selectedGoblet !== null ? String(selectedGoblet) : ''}
        onChange={handleChange}
        label={goblets.length > 0 ? RequiredLabel(label, true) : undefined}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200, // Restricts the height of the dropdown
              overflowY: 'auto', // Enables vertical scrolling
            },
          },
        }}
        sx={{
          height: '52px',
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} /> &nbsp; Loading...
          </MenuItem>
        ) : goblets.length ? (
          goblets.map((goblet) => (
            <MenuItem key={goblet.id} value={goblet.id}
              disabled={goblet.occupancy === 100}>
              <Box className="tank-item">
                <Typography className="tank-item-header"sx={{ 
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 700,
                  fontSize: '12px',
                }}>
                  {goblet.name}
                  <span className="tank-progress-text">
                    {(goblet.occupancy ?? 0).toFixed(2)}%
                  </span>
                </Typography>
                <Box className="progress-bar-container">
                  <LinearProgress
                    variant="determinate"
                    value={goblet.occupancy ?? 0}
                    className="progress-bar"
                    sx={{
                      backgroundColor: '#e0e0e0',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor:'68B62B'
                      },
                    }}
                  />
                </Box>
              </Box>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>Vials</MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default GobletSelect;